
export const newUserEndpoint = 'https://go.boppermusic.com/l/1042251/2023-10-09/6yjgf2';
export const newsletterSignupEndpoint = 'https://go.boppermusic.com/l/1042251/2023-10-09/6yjtmv';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/pardot/endpoints.ts